import React, { CSSProperties } from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';

export interface VariantModel {
  link: string;
  products_id: number;
  products_image: string;
  variants: any;
}

interface VariantsManagerProp {
  variants: VariantModel[];
  thisProductId: number;
  productTittle: string;
}

interface VariantsManagerState {
  propertyNameList: string[];
  thisVariant: VariantModel;
}

interface VariantsItem {
  value: string;
  productID?: number;
  productLink?: string;
  score: number;
}

export function getPropertyNameListStatic(
  variants: VariantModel[],
  thisProductId?: number,
) {
  let propertyNameList: string[] = [];
  let thisVariant = null;

  if (variants != undefined && variants != null) {
    for (let i = 0; i < variants.length; i++) {
      if (variants[i].products_id == thisProductId) {
        thisVariant = variants[i];
      }
      let keys = Object.keys(variants[i].variants);
      for (let j = 0; j < keys.length; j++) {
        let currentKey = keys[j];

        if (propertyNameList.indexOf(keys[j]) < 0) {
          let values = [];
          for (let k = 0; k < variants.length && values.length < 2; k++) {
            if (
              variants[k].variants[currentKey] != undefined &&
              variants[k].variants[currentKey] != null &&
              values.indexOf(variants[k].variants[currentKey]) < 0
            )
              values.push(variants[k].variants[currentKey]);
          }
          if (values.length > 1) {
            propertyNameList.push(currentKey);
            propertyNameList.sort();
          }
        }
      }
    }
  }

  return { propertyNameList: propertyNameList, thisVariant: thisVariant };
}
export default class VariantsManager extends React.Component<
  VariantsManagerProp,
  VariantsManagerState
> {
  constructor(prop: VariantsManagerProp) {
    super(prop);

    let propItems = this.getPropertyNameList();

    this.state = {
      propertyNameList: propItems.propertyNameList,
      thisVariant: propItems.thisVariant,
    };
  }

  getPropertyNameList() {
    return getPropertyNameListStatic(
      this.props.variants,
      this.props.thisProductId,
    );
  }

  getItems(
    currentName: string,
    propertyNameList: string[],
    thisVariant: VariantModel,
  ) {
    let propertyValues = [];
    let i1: number = 0;
    let j1: number = 0;
    let k1: number = 0;

    for (i1 = 0; i1 < this.props.variants.length; i1++) {
      let value = this.props.variants[i1].variants[currentName];
      if (value != undefined && propertyValues.indexOf(value) < 0) {
        propertyValues.push(value);
        propertyValues.sort();
      }
    }

    let items: VariantsItem[] = [];

    for (i1 = 0; i1 < propertyValues.length; i1++) {
      let bestItem = thisVariant;
      let bestItemScore = -1;
      let currentValue = propertyValues[i1];
      for (j1 = 0; j1 < this.props.variants.length; j1++) {
        if (
          (thisVariant == null ||
            thisVariant.products_id != this.props.variants[j1].products_id) &&
          this.props.variants[j1].variants[currentName] == currentValue
        ) {
          let curentScore: number = 0;
          for (k1 = 0; k1 < propertyNameList.length; k1++) {
            if (
              thisVariant == null ||
              this.props.variants[j1].variants[propertyNameList[k1]] ==
                thisVariant.variants[propertyNameList[k1]]
            ) {
              curentScore = curentScore + 1;
            }
          }
          if (curentScore > bestItemScore) {
            bestItem = this.props.variants[j1];
            bestItemScore = curentScore;
          }
        }
      }
      if (bestItem != null)
        items.push({
          value: propertyValues[i1],
          productID: bestItem.products_id,
          productLink: bestItem.link,
          score: bestItemScore,
        });
      else
        items.push({
          value: propertyValues[i1],
          productID: null,
          productLink: null,
          score: -1,
        });
    }
    return items;
  }

  render() {
    return (
      <div className="variantsBox">
        {this.state.propertyNameList.length > 0
          ? this.state.propertyNameList
              .map((currentPropertName, index) => {
                let currentItems = this.getItems(
                  currentPropertName,
                  this.state.propertyNameList,
                  this.state.thisVariant,
                );
                let thisValue = null;
                if (this.state.thisVariant != null)
                  thisValue =
                    this.state.thisVariant.variants[currentPropertName];

                if (currentItems.length > 1)
                  return (
                    <VariantsController
                      kategory={currentPropertName}
                      items={currentItems}
                      thisValue={thisValue}
                      key={'variant' + index}
                      propertCount={this.state.propertyNameList.length}
                      productTittle={this.props.productTittle}
                    />
                  );
              })
              .reduce((prev, curr) => {
                return (
                  <>
                    {prev}
                    <br />
                    {curr}
                  </>
                );
              })
          : null}
      </div>
    );
  }
}

function VariantsController(props: {
  kategory: string;
  items: VariantsItem[];
  thisValue: string;
  propertCount: number;
  productTittle: string;
}) {
  return (
    <div className="variantContainer">
      <span className="variantType">{props.kategory}:</span>
      {props.items.map((item, index) => {
        if (item.productID != null) {
          let classname = 'variant';

          if (item.value == props.thisValue) {
            classname += ' activ';
          } else if (item.score < props.propertCount - 1) {
            classname += ' inactiv';
          }

          return (
            <div
              className={classname}
              key={'variant_' + props.kategory + '_' + index}
            >
              <MolLink
                to={'/product_info/' + item.productID}
                href={item.productLink}
                title={
                  props.productTittle +
                  ' ' +
                  props.kategory +
                  ' - ' +
                  item.value
                }
              >
                {item.value}
              </MolLink>
            </div>
          );
        }
      })}
    </div>
  );
}
